<template>
	<div id="hotels-for-trees-placeholder" />
</template>

<script setup lang="ts">
useHead({
	script: [
		{
			src: 'https://api.hotelsfortrees.com/api/v1/widget/index.js?hotel_id=491d139c-45a9-4fb6-b797-121407ee62a0&mode=light&width=160&height=137',
		},
	],
	bodyAttrs: {
		class: 'hotels-for-trees',
	},
});

onMounted(async () => {
	await nextTick();

	// Controleer of we in de browser zijn
	if (typeof window === 'undefined' || typeof document === 'undefined') {
		return;
	}

	// Zoek de widget en de placeholder
	const widget = document.querySelector('.minty-flex.minty-flex-col') as HTMLElement | null;
	const placeholder = document.getElementById('hotels-for-trees-placeholder') as HTMLElement | null;

	if (widget && placeholder) {
		const positionWidget = () => {
			const rect = placeholder.getBoundingClientRect();
			widget.style.position = 'absolute';
			widget.style.top = `${rect.top + window.scrollY}px`;
			widget.style.left = `${rect.left + window.scrollX}px`;
			widget.style.zIndex = '9999';
		};
		positionWidget();

		window.addEventListener('resize', positionWidget);
		window.addEventListener('scroll', positionWidget);
	}
});
</script>

<style lang="scss" scoped>
#hotels-for-trees-placeholder {
	width: 160px;
	height: 137px;
	position: relative;
	margin: 0;
}
</style>
